export default "__VITE_ASSET__CQTg6kpC__"